import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';
import { environment } from '../../environments/environment';
import { apiFailureDisplayMessage, classifyApiFailure } from '../errors/api-failure';
import { CORRELATION_ID_HEADER } from './correlation-id.interceptor';
import { SKIP_ERROR_TOAST } from './http-context';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isExpectedGeofenceMatchMiss =
        req.method === 'GET' &&
        error.status === 400 &&
        req.url.includes('/service-zones/match');

      if (isExpectedGeofenceMatchMiss) {
        return throwError(() => error);
      }

      const classified = classifyApiFailure(error, {
        requestReferenceId: req.headers.get(CORRELATION_ID_HEADER),
        loginRequest: req.url.includes('/auth/login'),
      });

      // Callers that handle their own errors (inline field errors, warnings)
      // opt out of the generic toast via SKIP_ERROR_TOAST.
      const suppressForLocalBypass = error.status === 0 && environment.bypassAuth;
      if (error.status !== 401 && !suppressForLocalBypass && !req.context.get(SKIP_ERROR_TOAST)) {
        messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: apiFailureDisplayMessage(classified),
          life: 5000,
        });
      }

      return throwError(() => classified);
    }),
  );
};
